<div class="flex flex-wrap justify-end gap-4 filters-wrapper">

  <p-dropdown
      [options]="optionsSecurityCount"
      id="securityCount"
      [(ngModel)]="securityCount"
      (onChange)="onSearch()"></p-dropdown>

  <button
    class="py-1 px-5 border border-[#d9d9d9] rounded"
    (click)="onGroupMapClick()"
    [disabled]="selectedSecurity.length < 2"
    [ngClass]="{
      'bg-[#1f273b] text-white cursor-pointer hover:bg-[#2a334a]':
        selectedSecurity.length >= 2,
      'bg-white text-gray-800 cursor-not-allowed': selectedSecurity.length < 2
    }"
    pTooltip="{{
      selectedSecurity.length < 2
        ? 'Select at least two rows to enable grouping'
        : ''
    }}"
    tooltipPosition="top"
  >
    Group Map
  </button>

  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="searchBySecurityType"
    type="text"
    placeholder="Search by security type"
    class="border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'searchBySecurityType')"
  />
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="searchByName"
    type="text"
    placeholder="Search by issuer name"
    class="border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'searchByName')"
  />
</div>

<div class="mb-4">
  <p-table
    [value]="unprocessedSecurity"
    [paginator]="unprocessedSecurity.length > 0"
    [first]="first"
    (onLazyLoad)="loadData($event)"
    [lazy]="true"
    [totalRecords]="paginator.totalCount"
    [rows]="paginator.pageSize"
    [loading]="isLoading"
    [showCurrentPageReport]="true"
    [tableStyle]="{ 'min-width': '50rem' }"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    (onPage)="pageChange($event)"
    [(selection)]="selectedSecurity"
    dataKey="asReportedSecurityId"
    [rowsPerPageOptions]="[10, 25, 50]"
  >
    <ng-template #header>
      <tr>
        <th style="width: 4rem">
          <p-tableHeaderCheckbox/>
        </th>

        <th>A R. Id</th>
        <th>Filing ID</th>
        <th>Security Type</th>
        <th>Issuer Name</th>
        <th>Issuer ID</th>
        <th>URL</th>

        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template #body let-product>
      <tr>
        <td>
          <p-tableCheckbox [value]="product"/>
        </td>
        <td>
          {{ product.asReportedSecurityId || "N/A" }}
        </td>
        <td>
          <a
            *ngIf="product.filingId; else empty"
            [href]="
              '/inbox?filingId=' +
              product.filingId +
              '&filingState=' +
              product.filingState
            "
            [style.color]="'#4a90e2'"
            [style.cursor]="'pointer'"
            [style.text-decoration]="'underline'"
            rel="noopener"
            target="_blank"
          >{{ product.filingId }}</a
          >

          <ng-template #empty>
            <span>-</span>
          </ng-template>
          <!-- {{ product.filingId || "N/A" }} -->
        </td>
        <td
          style="
            max-width: 250px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          "
        >
          <span
            [pTooltip]="product.asReportedSecurityType"
            tooltipPosition="top"
            [tooltipStyleClass]="'custom-tooltip'"
            [autoHide]="false"
            [tooltipDisabled]="!product.asReportedSecurityType"
            class="block overflow-hidden text-ellipsis whitespace-nowrap"
          >
            {{ product.asReportedSecurityType || "N/A" }}
          </span>
        </td>
        <!-- <td>{{ product.asReportedSecurityType || "N/A" }}</td> -->

        <td>{{ product.asReportedIssuerName || "N/A" }}</td>
        <td [pTooltip]="product.securityTypes?.split('|')?.join('\n')">{{ product.issuerId || "N/A" }}</td>
        <td>
          <a href="{{ product.xbrl }}" *ngIf="product.xbrl" target="_blank"
          >Link</a
          >

          <span *ngIf="!product.xbrl">-</span>
        </td>
        <td>
          <button
            class="bg-white cursor-pointer hover:bg-gray-100 text-gray-800 py-1 px-3 border border-gray-400 rounded"
            (click)="openMapModal(product, $event)"
          >
            Map
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-container *ngIf="!isLoading && unprocessedSecurity.length === 0">
  <div class="text-center py-6 text-gray-500">No record found.</div>
</ng-container>
